import { GraphQLClient } from 'graphql-request';
import Cookie from 'js-cookie';

import { NEXT_PUBLIC_GRAPHQL_ENDPOINT } from './env';

const endpoint = NEXT_PUBLIC_GRAPHQL_ENDPOINT;

const voizGraphqlClient = (token) => {
  if (!token) {
    token = Cookie.get('auth_token');
  }

  const client = new GraphQLClient(`${endpoint.replace('/graphql', '')}/graphql`);
  client.setHeader('X-User-Agent', 'Voiz Admin')

  if (token) {
    client.setHeader('Authorization', `Bearer ${token}`);
  }

  const request = async (query, variables = {}) => {
    try {
      return await client.request(query, variables);
    } catch (error) {
      if (error.response) {
        error.message = error.response.errors?.map((e) => e.message).join('\n')
          || `GraphQL Error (Code: ${error.response.status})`;
      }
      throw error;
    }
  };

  return {
    query: request,
    mutation: request,
  };
};

export default voizGraphqlClient;
